import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";
import { ComuneDTO } from "@app/shared/dto/anagrafe/comuneDTO";
import { CartaceoDTO } from "@app/shared/dto/anagrafe/cartaceoDTO";
import { ApaciDTO } from "@app/shared/dto/anagrafe/apaciDTO";
import { PecDTO } from "@app/shared/dto/anagrafe/pecDTO";
import { MailDTO } from "@app/shared/dto/anagrafe/mailDTO";
import { PortaleWebDTO } from "@app/shared/dto/anagrafe/portale-webDTO";
import { AnagraficaCampoSpecificoDTO } from "@app/shared/dto/anagrafica-campo-specificoDTO";
import { AnagraficaCampoSpecificoVO } from "@app/shared/vo/anagrafica-campo-specificoVO";
import { MapperUtente } from "../mapper-utente";
import { ValoreCampoVO } from "@app/shared/vo/valori-campoVO";

@Injectable({
  providedIn: "root",
})
export class MapperAnagCampoSpecifico
  implements
    MapperInterface<AnagraficaCampoSpecificoDTO, AnagraficaCampoSpecificoVO> {
  constructor(private utenteMapper: MapperUtente) {}
  convertVoToDto(e: AnagraficaCampoSpecificoVO): AnagraficaCampoSpecificoDTO {
    const anagraficaCampoSpecificoDTO = new AnagraficaCampoSpecificoDTO();
    anagraficaCampoSpecificoDTO.id = e.id;
    anagraficaCampoSpecificoDTO.dataCreazione = e.dataCreazione;
    anagraficaCampoSpecificoDTO.dataModifica = e.dataModifica;
    anagraficaCampoSpecificoDTO.valori = e.listaValori;
    anagraficaCampoSpecificoDTO.nomeCampo = e.nomeCampo;
    anagraficaCampoSpecificoDTO.tipoCampo = e.tipoCampo;
    anagraficaCampoSpecificoDTO.operatore = this.utenteMapper.convertVoToDto(
      e.operatore
    );

    return anagraficaCampoSpecificoDTO || new AnagraficaCampoSpecificoDTO();
  }
  convertDtoToVo(t: AnagraficaCampoSpecificoDTO): AnagraficaCampoSpecificoVO {
    const anagraficaCampoSpecificoVO = new AnagraficaCampoSpecificoVO();
    anagraficaCampoSpecificoVO.id = t.id;
    anagraficaCampoSpecificoVO.dataCreazione = t.dataCreazione;
    anagraficaCampoSpecificoVO.dataModifica = t.dataModifica;
    anagraficaCampoSpecificoVO.listaOutput = new Array<ValoreCampoVO>();
    for (let index = 0; index < t.valori.length; index++) {
      const valoreCampo =  new ValoreCampoVO();
      valoreCampo.valore = t.valori[index];
      if (t.tipoCampo === "DATA") {
        valoreCampo.valorePipe = new Date(t.valori[index]).toLocaleDateString();
      } else   {
        valoreCampo.valorePipe = t.valori[index];
      }
     
      anagraficaCampoSpecificoVO.listaOutput.push(valoreCampo);
    }
    anagraficaCampoSpecificoVO.listaValori = t.valori;
    anagraficaCampoSpecificoVO.nomeCampo = t.nomeCampo;
    anagraficaCampoSpecificoVO.tipoCampo = t.tipoCampo;
    
    anagraficaCampoSpecificoVO.operatore = this.utenteMapper.convertDtoToVo(
      t.operatore
    );

    return anagraficaCampoSpecificoVO || new AnagraficaCampoSpecificoVO();
  }
  convertListVoToDto(
    e: AnagraficaCampoSpecificoVO[]
  ): AnagraficaCampoSpecificoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    t: AnagraficaCampoSpecificoDTO[]
  ): AnagraficaCampoSpecificoVO[] {
    throw new Error("Method not implemented.");
  }
}
